import { ReactNode } from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }: { children: ReactNode }) => {
    const isAuth = localStorage.getItem("auth") === "true";

  return isAuth ? children : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
